import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddBreedingFarmMutation, useDeleteBreedingFarmMutation, useEditBreedingFarmMutation } from "../../../redux/api/breedingFarm/breedingFarmApi";
import { EntBreedingFarm } from "../../../models/breedingFarm";
import { getCookie } from "typescript-cookie";



const useBreedingFarm = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addBreedingFarms] = useAddBreedingFarmMutation();
    const [deleteBreedingFarms] = useDeleteBreedingFarmMutation();
    const [editBreedingFarms] = useEditBreedingFarmMutation();

    async function onAddBreedingFarm(newBreedingFarms: EntBreedingFarm): Promise<boolean> {
        try {
            let status: boolean = false;
            await addBreedingFarms(newBreedingFarms).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError');
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeleteBreedingFarm(breedingFarm: EntBreedingFarm) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteBreedingFarms(breedingFarm.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    async function onEditBreedingFarm(editedBreedingFarm: EntBreedingFarm): Promise<boolean> {
        try {
            let status: boolean = false;
            await editBreedingFarms(editedBreedingFarm).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    return { onAddBreedingFarm, onDeleteBreedingFarm, onEditBreedingFarm }

}
export { useBreedingFarm };

